<template>
  <b-card>
    <FormView
      :data="$store.getters['questionCategory/detailData']"
      :fields="$store.getters['questionCategory/tableFields']"
      @load="loadData"
    />
  </b-card>
</template>

<script>
import FormView from '@/layouts/components/FormView.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    FormView,
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('questionCategory/getDetail', id)
    },
  },
}
</script>

<style scoped>

</style>
